import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * Mission Ready brand input.
 * - Background: card surface (#1A1A1A)
 * - Border: chrome silver (#C0C0C0)
 * - Text: white; placeholder: #999
 * - Focus: deep red border + subtle red glow
 * - Error: aria-invalid → red border + red glow
 * - Success: data-state="success" → green border
 */
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border bg-card px-3 py-2 text-base text-foreground shadow-sm transition-colors",
          "border-[#C0C0C0]/60 placeholder:text-muted-foreground",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-primary/40",
          "disabled:cursor-not-allowed disabled:bg-[#333] disabled:text-[#666] disabled:border-[#C0C0C0]/20",
          "aria-[invalid=true]:border-destructive aria-[invalid=true]:ring-2 aria-[invalid=true]:ring-destructive/30",
          "data-[state=success]:border-success",
          "md:text-sm",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
